"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isScheduleEventSuccess = exports.PRIORITY_NOT_SET = exports.PRIORITY_MIN = exports.PRIORITY_MAX = void 0;
var PRIORITY_NOT_SET = exports.PRIORITY_NOT_SET = {
  value: -1
};
var PRIORITY_MIN = exports.PRIORITY_MIN = {
  value: 0
};
var PRIORITY_MAX = exports.PRIORITY_MAX = {
  value: 100
};
var isScheduleEventSuccess = exports.isScheduleEventSuccess = function isScheduleEventSuccess(response) {
  return response.code === 0;
};